import { Select } from 'antd';
import React from 'react';
import { useAllDatasets } from '../../../lib/hooks';

interface Props {
  datasetId: string | null;
  setDatasetId: (id: string) => void;
}

export const DatasetSelection = ({ datasetId, setDatasetId }: Props) => {
  const { datasets, loading } = useAllDatasets();

  const onSelectHandler = (value: any) => {
    setDatasetId(value ? value['value'] : null);
  };

  return (
    <>
      <Select
        allowClear
        className="w-full"
        showSearch
        placeholder="Select a dataset"
        optionFilterProp="children"
        loading={loading}
        dropdownMatchSelectWidth={true}
        onChange={onSelectHandler}
        filterOption={(input, option) => ((option?.label ?? '') as string).toLowerCase().includes(input.toLowerCase())}
        labelInValue={true}
        style={{ width: '100%', margin: '0px 0px 20px 0px' }}
        options={
          datasets &&
          datasets.map(dataset => {
            return { value: dataset.id, label: dataset.name };
          })
        }
      />
    </>
  );
};
